import React, { Component } from 'react'
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux'
import { Link } from "react-router-dom"
import classNames from 'classnames';

import agent from '../agent'

import companyBanner from '../assets/images/check-in-expanded-01-copy-9-lukas-blazek-261681-unsplash.png'
import companyLogo from '../assets/images/check-in-expanded-01--col-company-logo@2x.png'
import project1 from '../assets/images/expanded-project-responsive-tesla-copy.png'
import project2 from '../assets/images/expanded-project-poster-2.png'
import project3 from '../assets/images/check-in-expanded-01-copy-9-reebok.png'
import line from '../assets/images/expanded-project--col-line-2.png'
import amlogo from '../assets/images/company-client-landing-page-auditionmagiciconplain@2x.png'

class CheckinArtist extends Component {

	render(){
		return (
            <div className="expandedprojectcol">
            <div className="registration-wrapper">
                <div className="header">
                    <img className="lukasblazek261681unsplash" src={companyBanner}/>
                    <img className="companylogo" src={companyLogo}/>
                </div>
                <div className="group4">
                    <div className="rectanglecopy2" />
                    
                    <div className="group6">
                        <div className="group10">
                            <div className="group7copy">
                                <div className="rectangle">
                                </div>
                                <div className="appletvcommercial">
                                    APPLE TV COMMERCIAL
                                </div>
                            </div>
                            <div className="teslacopy2">
                                <div className="mask">
                                </div>
                                <img className="poster" src={project1}/>
                            </div>
                        </div>
                        <div className="group10copy">
                            <div className="group7copy">
                                <div className="rectangle">
                                </div>
                                <div className="appletvcommercial">
                                    APPLE TV COMMERCIAL
                                </div>
                            </div>
                            <div className="teslacopy2">
                                <div className="mask">
                                </div>
                                <img className="poster" src={project2}/>
                            </div>
                        </div>
                        <div className="group11">
                            <div className="group7copy2">
                                <div className="rectangle">
                                </div>
                                <div className="reeboktvcommercial">
                                    REEBOK TV COMMERCIAL
                                </div>
                            </div>
                            <div className="teslacopy3">
                                <div className="mask">
                                </div>
                                <img className="reebok" src={project3}/>
                            </div>
                        </div>
                    </div>
                    
                    <div className="group2">
                        <div className="rectangle9copy">
                        </div>
                        <img className="auditionmagiciconplain" src={amlogo} />
                        <div className="group5">
                            <div className="poweredbyaudition">
                                Powered by Audition Magic copyright © 2018
                            </div>
                        </div>
                    </div>
                    
                        
                        
                    
                    <div className="group6copy">
                        <div className="group10">
                            <div className="group7copy">
                                <div className="rectangle">
                                </div>
                                <div className="appletvcommercial">
                                    APPLE TV COMMERCIAL
                                </div>
                            </div>
                            <div className="teslacopy2">
                                <div className="mask">
                                </div>
                                <img className="poster" src={project2}/>
                            </div>
                        </div>
                        <div className="group10copy">
                            <div className="group7copy">
                                <div className="rectangle">
                                </div>
                                <div className="appletvcommercial">
                                    APPLE TV COMMERCIAL
                                </div>
                            </div>
                            <div className="teslacopy2">
                                <div className="mask">
                                </div>
                                <img className="poster" src={project2}/>
                            </div>
                        </div>
                        <div className="group11">
                            <div className="group7copy2">
                                <div className="rectangle">
                                </div>
                                <div className="reeboktvcommercial">
                                    REEBOK TV COMMERCIAL
                                </div>
                            </div>
                            <div className="teslacopy3">
                                <div className="mask">
                                </div>
                                <img className="reebok" src={project3}/>
                            </div>
                        </div>
                    </div>
                    <img className="line2" src={line}/>
                </div>




                <div className="group3">
                    <img className="oval" src=""/>
                    <div className="lock">
                        <img className="path" />
                        <img className="path1" />
                    </div>
                </div>
                <div className="auditionprojectreg">
                    AUDITION PROJECT REGISTRATION PAGE
                </div>
                <div className="tabs">
                    <div className="groupcopy">
                        <div className="rectangle">
                        </div>
                        <div className="checkin">
                            CHECK-IN
                        </div>
                    </div>
                    <div className="group">
                        <div className="rectangle">
                        </div>
                        <div className="register">
                            REGISTER
                        </div>
                    </div>
                </div>
                <div className="listedbelowarethe">
                    LISTED BELOW ARE THE CURRENT PROJECT OPPORTUNITIES AVAILABLE TO REGISTER FOR &amp; OPEN FOR REGISTRATION
                </div>
            </div>
        </div>
        )
	}
}

CheckinArtist = reduxForm({
  form: 'checkinWizard', // <------ same form name
  destroyOnUnmount: true, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate
})(CheckinArtist)

const mapStateToProps = (state, ownProps) => {

}


const mapDispatchToProps = (dispatch) => ({
	setSignature: sig => dispatch(change( "checkinWizard", "signature", sig)),
	submitPublicRegistration: payload =>
		dispatch({ type: 'SUBMIT_CHECKIN', payload: agent.Artist.checkin(payload) })
})

export default connect(mapStateToProps, mapDispatchToProps)(CheckinArtist)


// WEBPACK FOOTER //
// ./src/containers/CheckinArtist.js